import { useMemo } from 'react';
import { find, isNumber } from 'lodash';
import { RootState } from '../../../store/store';
import { DictionaryItem } from '../../../core/types/coreTypes';
import { useAppSelector } from '../../../store/hooks';

type DictionarySelector = (state: RootState) => DictionaryItem[];

export const useDictionaryItem = (selector: DictionarySelector, value?: number | null): string | null => {
  const items = useAppSelector(selector);

  return useMemo(() => {
    if (!isNumber(value)) {
      return null;
    }

    const unit = find(items, { value });

    if (!unit) {
      return null;
    }

    return unit.label;
  }, [items, value]);
};
